import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { Key_knowledgeSubDomains } from "../utils/constants";
import { getKnowledgeSubDomains } from "../services/school/knowledgedomains/knowledgeSubDomain";

export const useGetKnowledgeSubDomainsQuery = (data: PagedRequestType, options:any= null) => {
    return useQuery(
        [Key_knowledgeSubDomains, JSON.stringify(data)],
        () => getKnowledgeSubDomains(data), 
        options?{...options}:{}
    );
};
